import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {TextRow, Indent, InputRow, TextAreaRow, DropdownRow, MultiLineRow, SwitchRow, SectionHeader, PageHeader } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE } from '../../../Components/Worksheets/Types/Worksheet.Interface';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
        <PageHeader {...page} 
        subheading=""
        > General Review Reply </PageHeader>
        
       
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.ReviewReplyGeneral}
        /><SectionHeader {...page}  >5 Star Review Reply</SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.ReviewReply5Star}
        />
        <SectionHeader {...page}  >Promoter Review Reply</SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.ReviewReplyPromoter}
        />
        <SectionHeader {...page}  > Passive Review Reply</SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.ReviewReplyPassive}
        />
        <SectionHeader {...page}  >Detractor Review Reply</SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.ReviewReplyDetractor}
        />
        <SectionHeader {...page}  > 1 Star Review Reply</SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.ReviewReply1Star}
        />

    </>
}